import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from '../../../shared/locale/en.json' with { type: 'json' };
import enUS from '../../../shared/locale/en-US.json' with { type: 'json' };
import ja from '../../../shared/locale/ja.json' with { type: 'json' };
import ko from '../../../shared/locale/ko.json' with { type: 'json' };
import zhCN from '../../../shared/locale/zh-CN.json' with { type: 'json' };
import zhTW from '../../../shared/locale/zh-TW.json' with { type: 'json' };

import { normalizeLocale } from '../../../shared-site-web/locales.js';

// The marketing site (site/) merges its own locale files into the same
// i18next instance and initialises it first. If this module is imported
// after that (e.g. via a reused web component), skip re-initialising so the
// site's merged resources are never clobbered by the app-only set.
if (!globalThis.__THYME_I18N_INITIALISED__) {
	i18n
		.use(LanguageDetector)
		.use(initReactI18next)
		.init({
			resources: {
				en: { translation: en },
				'en-US': { translation: enUS },
				ja: { translation: ja },
				ko: { translation: ko },
				'zh-CN': { translation: zhCN },
				'zh-TW': { translation: zhTW },
			},
			fallbackLng: 'en',
			interpolation: { escapeValue: false },
			detection: {
				order: ['localStorage', 'navigator'],
				caches: ['localStorage'],
				// Normalise every detected language to a canonical code that has
				// a resource before i18next loads it: en-US stays the US variant,
				// other English (en, en-GB, …) falls back to British English,
				// ja-JP → ja, and Chinese region tags map to their shared
				// variant (zh → zh-CN, zh-HK/zh-MO/zh-Hant → zh-TW). Without
				// this, i18next cannot resolve zh-HK/bare zh and renders English.
				convertDetectedLanguage: (lng) => normalizeLocale(lng ?? ''),
			},
		});
	globalThis.__THYME_I18N_INITIALISED__ = true;
}

// Keep the <html lang> attribute and Content-Language meta in step with the
// active language so the browser (e.g. Safari Translate) treats the page as
// its language. index.html seeds both from localStorage/navigator before
// the bundle runs (inline script) and defaults to lang="en", so this must
// follow every language change: the initial detector result, the saved
// server-side locale applied by useAppBootstrap, and the user's Settings
// toggle.
/** @returns {void} */
function syncDocumentLang() {
	if (typeof document === 'undefined') { return; }
	const lang = i18n.language ? normalizeLocale(i18n.language) : 'en';
	document.documentElement.lang = lang;
	const meta = document.querySelector('meta[http-equiv="Content-Language"]');
	if (meta) { meta.setAttribute('content', lang); }
}
syncDocumentLang();
i18n.on('languageChanged', syncDocumentLang);

export { i18n };
